import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { GatewayRulesCreate } from './GatewayRulesCreate';
import { GatewayRulesEdit } from './GatewayRulesEdit';
import { GatewayRulesList } from './GatewayRulesList';
import { GatewayRulesShow } from './GatewayRulesShow/GatewayRulesShow';

export const gatewayRulesResource: ResourceProps = {
  name: Resources.GatewayRules,
  create: GatewayRulesCreate,
  edit: GatewayRulesEdit,
  list: GatewayRulesList,
  show: GatewayRulesShow,
};
